import type React from 'react';
import { componentRegistry } from '../components';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function registerComponent<T extends React.ComponentType<any>>(name: string, component: T): void {
  if (componentRegistry.has(name)) {
    console.warn(`Component with name "${name}" is already registered. Overwriting.`);
  }
  componentRegistry.set(name, component);
}

export function getComponent(name: string): React.ComponentType<unknown> | undefined {
  return componentRegistry.get(name);
}
